var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseSelect',{attrs:{"options":_vm.options,"reduce":_vm.reduce,"validation":_vm.validation},model:{value:(_vm.toy),callback:function ($$v) {_vm.toy=$$v},expression:"toy"}})}
var staticRenderFns = []

export { render, staticRenderFns }